// extracted by mini-css-extract-plugin
export default {"accordion":"Filters_accordion__uUFeZ"};